import React, {Fragment} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import WizardPopupEditCustomIconUploadButton from "./WizardPopupEditCustomIconUploadButton";
import WizardPopupEditGroupUploadButton from "./WizardPopupEditGroupUploadButton";
import CheckBox from "../../../PageLayout/CheckBox";
import {getWizardGroupLogic} from "../../wizardFunctions";
import {WIZARD_POPUP_TYPES} from "../../wizardReducer";
import {WIZARD_GROUP_TYPES} from "../../WizardItem/wizardItemInterface";
import WizardPopupEditGroupLeadFormStepSelect from "./WizardPopupEditGroupLeadFormStepSelect";
import WizardPopupEditGroupVisualizerSelect from "./WizardPopupEditGroupVisualizerSelect";
import {AVAILABLE_VISUALIZERS} from "../../../../constants/dashboard";
import {COUNTERTOP_GROUPS} from "../../../../utilities/constants";
import WizardPopupEditGroupClickFeatureSelect from "./WizardPopupEditGroupClickFeatureSelect";
import WizardPopupEditGroupMatchAllCheckbox from "./WizardPopupEditGroupMatchAllCheckbox";

const WizardPopupEditGroup = (props) => {

  const {intl, wizardPopupGroup, wizardPopupItem, wizardPopupType, wizardVisualizer} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {title, description, productCartTitle, productCartDescription, notRequired, multipleAddToCart, separateSqftLabel,
    isCenterIslandGroup, hideInCartAndReceipt, skipProductInfo, headerTitle, headerSubTitle, skipStartStep,
    hidePriceNoCart, skipLockDontApply, dontMatchFeaturesBySku, matchAllDisabled} = wizardPopupState;

  const changeInputValue = (property, newValue) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        [property]: newValue
      }
    });
    if (property === "hidePriceNoCart" && newValue && skipProductInfo) {
      wizardPopupDispatch({
        type: wizardPopupAction,
        payload: {
          "skipProductInfo": false
        }
      });
    } else if (property === "skipProductInfo" && newValue && hidePriceNoCart) {
      wizardPopupDispatch({
        type: wizardPopupAction,
        payload: {
          "hidePriceNoCart": false
        }
      });
    }
  }

  const menuSectionDisabled = false; // show it always cause it's a step name and description

  const isLeadForm = wizardVisualizer === AVAILABLE_VISUALIZERS.leadform;
  const isCustom = wizardPopupGroup.nodeType === WIZARD_GROUP_TYPES.custom;
  const isRegularGroup = wizardPopupGroup.nodeType === WIZARD_GROUP_TYPES.group;
  const isStart = wizardPopupType === WIZARD_POPUP_TYPES.start;

  const {productSectionDisabled} = getWizardGroupLogic(wizardPopupGroup, wizardPopupItem);
  let showCenterIslandCheckbox = false;
  let showSeparateSqftLabel = false;
  if (wizardPopupGroup.groupName && isRegularGroup) {
    const nameLowerCased = wizardPopupGroup.groupName.toLowerCase();
    if (nameLowerCased.includes("edge") || nameLowerCased.includes("sink") ||nameLowerCased.includes("faucet")) {
      showCenterIslandCheckbox = true;
    }
    showSeparateSqftLabel = COUNTERTOP_GROUPS.includes(wizardPopupGroup.groupName);
  }

  return (
    <div className={"wizard-popup" + (productSectionDisabled && !isLeadForm ? " wizard-popup--edit-only" : "")
      + (isCustom ? " wizard-popup--custom" : "")
      + (isLeadForm ? " wizard-popup--leadForm" : "")}>
      <div className="wizard-popup__title">
        <h3>{wizardPopupGroup.customDisplayName || wizardPopupGroup.groupName} <FormattedMessage id="wizard.popup.editGroupTitle"/></h3>
        {showCenterIslandCheckbox ? <CheckBox type={"tiny"}
                                              checked={isCenterIslandGroup}
                                              text={intl.formatMessage({id: "wizard.popup.isCenterIslandGroup"})}
                                              onChecked={() => changeInputValue("isCenterIslandGroup", !isCenterIslandGroup)} /> : null}
      </div>
      <div className="flex flex--top">
        <div className="wizard-popup__left flex-item">
          {isLeadForm ? (
            <Fragment>
              <div className="wizard-popup__block-input">
                <span className="generic-popup-title">Header Title</span>
                <input className="generic-popup-textbox"
                       placeholder="Header Title"
                       onChange={(event) => changeInputValue("headerTitle", event.target.value)}
                       value={headerTitle}/>
              </div>
              <div className="wizard-popup__block-input">
                <span className="generic-popup-title">Header SubTitle</span>
                <input className="generic-popup-textbox"
                       placeholder="Header SubTitle"
                       onChange={(event) => changeInputValue("headerSubTitle", event.target.value)}
                       value={headerSubTitle}/>
              </div>
            </Fragment>
          ) : null}
          <div className="wizard-popup__block-input">
              <span className={"generic-popup-title" + (menuSectionDisabled ? " generic-popup-title--disabled" : "")}>
                <FormattedMessage id="wizard.popup.editGroupMenuTitle"/>
              </span>
            <input className={"generic-popup-textbox" + (menuSectionDisabled ? " generic-popup-textbox--disabled" : "")}
                   disabled={menuSectionDisabled}
                   placeholder={intl.formatMessage({id: "wizard.item.title"})}
                   onChange={(event) => changeInputValue("title", event.target.value)}
                   value={menuSectionDisabled ? "" : title}/>
          </div>
          {isLeadForm ? null : ( // we are using headerTitle for leadForm and for navigation in the look journey
            <div className="wizard-popup__block-input">
              <span className="generic-popup-title">Group Title</span>
              <input className="generic-popup-textbox"
                     placeholder="Group Title"
                     onChange={(event) => changeInputValue("headerTitle", event.target.value)}
                     value={headerTitle}/>
            </div>
          )}
          <div className="wizard-popup__block-input">
              <span className={"generic-popup-title" + (menuSectionDisabled ? " generic-popup-title--disabled" : "")}>
                <FormattedMessage id="wizard.popup.editGroupMenuDescription"/>
              </span>
            <textarea className={"generic-popup-textarea"
              + (menuSectionDisabled ? " generic-popup-textarea--disabled" : "")
              + (productSectionDisabled ? " generic-popup-textarea--86" : "")}
                      disabled={menuSectionDisabled}
                      placeholder={intl.formatMessage({id: "wizard.item.description"})}
                      onChange={(event) => changeInputValue("description", event.target.value)}
                      value={menuSectionDisabled ? "" : description}/>
          </div>
          {isStart || productSectionDisabled ? null : (
            <Fragment>
              <div className="wizard-popup__block-input">
                <span className={"generic-popup-title" + (productSectionDisabled ? " generic-popup-title--disabled" : "")}>
                  <FormattedMessage id="wizard.popup.editGroupProductCardTitle"/>
                </span>
                <input className={"generic-popup-textbox" + (productSectionDisabled ? " generic-popup-textbox--disabled" : "")}
                       disabled={productSectionDisabled}
                       placeholder={intl.formatMessage({id: "wizard.item.title"})}
                       onChange={(event) => changeInputValue("productCartTitle", event.target.value)}
                       value={productSectionDisabled ? "" : productCartTitle}/>
              </div>
              {isLeadForm ? null : (
                <div className="wizard-popup__block-input">
                  <span className={"generic-popup-title" + (productSectionDisabled ? " generic-popup-title--disabled" : "")}>
                    <FormattedMessage id="wizard.popup.editGroupProductCardDescription"/>
                  </span>
                  <textarea className={"generic-popup-textarea" + (productSectionDisabled ? " generic-popup-textarea--disabled" : "")}
                            disabled={productSectionDisabled}
                            placeholder={intl.formatMessage({id: "wizard.item.description"})}
                            onChange={(event) => changeInputValue("productCartDescription", event.target.value)}
                            value={productSectionDisabled ? "" : productCartDescription}/>
                </div>
              )}
            </Fragment>
          )}
        </div>
        <div className="wizard-popup__right">
          {wizardVisualizer === AVAILABLE_VISUALIZERS.leadform ? (
            <div className="wizard-popup__block2">
              <WizardPopupEditGroupLeadFormStepSelect/>
            </div>
          ) : null}
          {wizardVisualizer === "all" && (wizardPopupGroup.groupName === "Room") ? (
            <div className="wizard-popup__block2">
              <WizardPopupEditGroupVisualizerSelect/>
            </div>
          ) : null}
          <div className="wizard-popup__block">
            <div className="wizard-popup__block-upload">
              <WizardPopupEditCustomIconUploadButton/>
            </div>
            {productSectionDisabled ? null : (
              <div className="wizard-popup__block-upload">
                <WizardPopupEditGroupUploadButton/>
              </div>
            )}
          </div>
          <div className="">
            {isCustom
              ? <CheckBox type={"tiny"}
                          checked={hideInCartAndReceipt}
                          text={intl.formatMessage({id: "wizard.popup.hideInCartAndReceipt"})}
                          onChecked={() => changeInputValue("hideInCartAndReceipt", !hideInCartAndReceipt)} />
              : null}
            {isStart ? (
              <Fragment>
                <CheckBox type={"tiny"}
                          checked={skipStartStep}
                          text={intl.formatMessage({id: "wizard.popup.skipStartStep"})}
                          onChecked={() => changeInputValue("skipStartStep", !skipStartStep)} />
              </Fragment>
            ) : (
              <Fragment>
                <CheckBox type={"tiny"}
                          checked={!notRequired}
                          text={intl.formatMessage({id: "checkbox.required"})}
                          onChecked={() => changeInputValue("notRequired", !notRequired)} />
                {isCustom
                  ? <WizardPopupEditGroupClickFeatureSelect/>
                  : <CheckBox type={"tiny"}
                              checked={multipleAddToCart}
                              text={intl.formatMessage({id: "wizard.popup.multipleAddToCart"})}
                              onChecked={() => changeInputValue("multipleAddToCart", !multipleAddToCart)} />}
              </Fragment>
            )}
            {showSeparateSqftLabel ? <CheckBox type={"tiny"}
                                               checked={separateSqftLabel}
                                               text={intl.formatMessage({id: "wizard.popup.separateSqftLabel"})}
                                               onChecked={() => changeInputValue("separateSqftLabel", !separateSqftLabel)} /> : null}
            {!isCustom && !isStart
              ? <CheckBox type={"tiny"}
                          checked={skipProductInfo}
                          text={intl.formatMessage({id: "wizard.popup.skipProductInfo"})}
                          onChecked={() => changeInputValue("skipProductInfo", !skipProductInfo)} />
              : null}
            {isRegularGroup && !isStart ? (
              <Fragment>
                <CheckBox type={"tiny"}
                          checked={hidePriceNoCart}
                          text={intl.formatMessage({id: "wizard.popup.hidePriceNoCart"})}
                          onChecked={() => changeInputValue("hidePriceNoCart", !hidePriceNoCart)} />
                <CheckBox type={"tiny"}
                          checked={skipLockDontApply}
                          text={intl.formatMessage({id: "wizard.popup.skipLockDontApply"})}
                          onChecked={() => changeInputValue("skipLockDontApply", !skipLockDontApply)} />
                <CheckBox type={"tiny"}
                          checked={dontMatchFeaturesBySku}
                          text={intl.formatMessage({id: "wizard.popup.dontMatchFeaturesBySku"})}
                          onChecked={() => changeInputValue("dontMatchFeaturesBySku", !dontMatchFeaturesBySku)} />
                <WizardPopupEditGroupMatchAllCheckbox wizardPopupGroup={wizardPopupGroup}
                                                      changeInputValue={changeInputValue}
                                                      matchAllDisabled={matchAllDisabled}/>
              </Fragment>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup, wizardPopupItem, wizardPopupType, wizardVisualizer} = store.wizardState;
  return {
    wizardPopupGroup,
    wizardPopupItem,
    wizardPopupType,
    wizardVisualizer,
  };
};

export default injectIntl(
  connect(mapStateToProps)(WizardPopupEditGroup)
)
